import { emitter } from '@phoenix/event-bus';

export function initModal(id, options = {}) {
  const modal = document.getElementById(id);
  if (modal) {
    window.Phoenix.modals[id] = new window.Toolkit.Modal(modal, options);
    emitter.emit(`modal-initialized-${id}`);
  }
}

export function destroyModal(id) {
  if (Object.hasOwn(window.Phoenix.modals, id)) {
    window.Phoenix.modals[id].destroy();
  }
}

export function showModal(id, props = {}) {
  if (Object.hasOwn(window.Phoenix.modals, id)) {
    window.Phoenix.modals[id].show(props);
  }
}

export function closeModal(id) {
  if (Object.hasOwn(window.Phoenix.modals, id)) {
    window.Phoenix.modals[id].hide();
  }
}

export function getModal(id) {
  return Object.hasOwn(window.Phoenix.modals, id) ? window.Phoenix.modals[id] : null;
}

export function listenModalInitialized(id, callback = () => {}) {
  if (getModal(id) !== null) {
    callback();
  } else {
    emitter.on(`modal-initialized-${id}`, callback);
  }
}

export function unlistenModalInitialized(id, callback = () => {}) {
  emitter.off(`modal-initialized-${id}`, callback);
}
